import login from './login';
import logout from './logout';
import newLogin from './newLogin';

export default {
  login,
  logout,
  newLogin,
};
